export const setCustomTimeout = (handler: () => void, timeout: number) => {
  const timeoutId = window.setTimeout(handler, timeout);

  return () => {
    window.clearTimeout(timeoutId);
  };
};
